module.exports = {"140321100":"冠山镇","140321101":"冶西镇","140321102":"锁簧镇","140321103":"张庄镇","140321104":"东回镇","140321105":"柏井镇","140321106":"娘子关镇","140321107":"巨城镇","140321200":"石门口乡","140321201":"岔口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140321.json
// module id = 288
// module chunks = 0